import './../styles/user-details.scss';
import ChangePasswordDialogTemplate from './../change-password/change-password-dialog.html';
import DeveloperNetworkSubscribeTemplate from './../developer-network/developer-network-subscribe.html';

export default /* @ngInject */ class {
    constructor(user, countryData, userService, responseHandler, $mdDialog, userGroup) {
        this.data = user;
        this.dependencies = {
          $mdDialog: $mdDialog,
          userService: userService,
          responseHandler: responseHandler
        };

        this.data.group = userGroup;

        userService.isBDN().then((response) => this.data.external_developer = response.member);

        responseHandler(countryData.query().$promise, 'fetching countries')
            .then((countries) => this.countries = countries);
    }

    showChangePassword(event) {
      let instance = this.dependencies.$mdDialog.show({
        controller: 'ChangePasswordDialogCtrl',
        controllerAs: 'change',
        templateUrl: ChangePasswordDialogTemplate,
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true
      });

      instance.then(() => this.form.setFormSuccess('Your password has been changed.', 2000));
    }

    showBDNSubscribe() {
      let instance = this.dependencies.$mdDialog.show({
        controller: 'DeveloperNetworkCtrl',
        controllerAs: 'bdn',
        templateUrl: DeveloperNetworkSubscribeTemplate,
        parent: angular.element(document.body),
        clickOutsideToClose: true
      });

      instance.then(() => this.data.external_developer = true);
    }

    submit() {
      let data = {
            first_name: this.data.first_name,
            last_name: this.data.last_name,
            receive_news: this.data.receive_news
          },
          promise = this.dependencies.userService.update(data);

      return this.dependencies.responseHandler(promise, 'update user data', this.form).then(() => {
        document.body.scrollTop = 0;
        this.form.$setPristine();
        this.form.setFormSuccess('Your profile has been updated');
      });
    }
}



// WEBPACK FOOTER //
// ./user/user-profile/user-profile-ctrl.js